const edit =
{
    agree       : 'Modier' ,
    description : 'Modifier l\'enregistrement.' ,
    disagree    : 'Annuler' ,
    elements    : [] ,
    title       : 'Éditer'
};

export default edit ;